import { isAfterNow } from '@bonanza-social/toolkit/utils';
import { CashbackPromotion } from '../../state/cashback/cashback.types';
import { CashbackPromotionStatus } from './CashbackCard.types';

export const getCashbackStatus = (
  cashbackPromo: CashbackPromotion,
): CashbackPromotionStatus => {
  const [reward] = cashbackPromo.rewards;
  let progress: CashbackPromotionStatus['progress'];

  if (reward.amount === reward.maxAmount) {
    progress = 'Full';
  } else if (reward.amount === 0) {
    progress = 'Empty';
  } else {
    progress = 'Progress';
  }

  return {
    state: isAfterNow(cashbackPromo.endDate) ? 'Active' : 'Inactive',
    progress,
  };
};
